import styled from "styled-components";
import {
  SCENSUM_WEBSITE_HEADER_HEIGHT,
  BFC_PROGRESS_BAR_HEIGHT_MOBILE,
} from "./constants/constants";

export const Main = styled.main`
  display: block;
  max-width: 1400px;
  height: auto;
  min-height: 100%;
  overflow-y: unset;
  margin: 0 auto;
  padding: calc(
      ${SCENSUM_WEBSITE_HEADER_HEIGHT} + ${BFC_PROGRESS_BAR_HEIGHT_MOBILE} +
        15px
    )
    15px calc(4 * 15px);

  @media (min-width: 768px) {
    padding-top: 15px;
    padding-bottom: calc(8 * 15px);
    min-height: 680px; // Calculated height of main container with content loaded for step1
  }

  @media (min-width: 1024px) {
    min-height: 634px; // Calculated height of main container with content loaded for step1
  }

  @media (min-width: 1200px) {
    min-height: 640px; // Calculated height of main container with content loaded for step1
  }
  @media (max-height: 470px) {
    padding-bottom: 20px;
    min-height: 100%;
  }
  @media (max-height: 600px) {
    padding-bottom: 40px;
    min-height: 470px;
  }
`;
